module.exports = __webpack_public_path__ + "assets/img/Goldenbell_bg.00018ae3.png";